import React from "react";
import API_URL from "../../../utils/apiUrl";
import getAuthToken from "../../../utils/getAuthToken";
import BlogCategory from "../../../components/templates/Blog/BlogCategory";
import BlogCategorySEO from "../../../components/molecules/seo/Blog/BlogCategorySEO";

const BlogCategoryPage = (props) => {
    return (
        <>
            <BlogCategorySEO blogCategory={props.blogCategory} />
            <BlogCategory {...props} />
        </>
    );
};

export default BlogCategoryPage;

const cacheFile = "temp-blog-categories-data.json";
export async function getStaticPaths() {
    const fs = require("fs");
    let { fetchBlogCategories } = require("../../../utils/fetchBuildData");
    const blogCategories = await fetchBlogCategories();

    const paths = [];
    blogCategories.forEach((category) =>
        paths.push({ params: { slug: category.slug } })
    );
    console.log("blogCategories", paths);

    // save to json file
    // we'll need this in the getStaticProps to map slugs to ids
    let data = JSON.stringify(blogCategories);
    fs.writeFileSync(cacheFile, data);

    return {
        paths: paths,
        fallback: false,
    };
}

export async function getStaticProps({ params }) {
    const axios = require("axios");
    const fs = require("fs");
    let { fetchBlogPosts } = require("../../../utils/fetchBuildData");

    // read cache
    const rawData = fs.readFileSync(cacheFile);
    const blogCategories = JSON.parse(rawData);
    const pk = blogCategories.find(
        (category) => category.slug === params.slug
    ).id;

    // <------------------------------------------- API calls --------------------------------------------------------------->
    // categories
    const authToken = await getAuthToken();
    const categoriesConfig = {
        method: "get",
        url: `${API_URL}/blog/blog_categories/${pk}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${authToken}`,
        },
    };
    const res = await axios(categoriesConfig);
    const blogCategory = res.data;

    // blog posts
    const blogPosts = await fetchBlogPosts();

    return {
        props: {
            blogCategory: blogCategory,
            blogPosts: blogPosts.filter((obj) => {
                return (
                    obj.blog_categories.filter((cat) => cat.slug == params.slug)
                        .length > 0
                );
            }),
        },
        // revalidate: 60 * 60 * 24 * 1, // 1 days
    };
}
